import type { FC } from "react";
import { useEffect } from "react";

import { PostAndForget } from "@/lib/fetch-helper";
import { BrowserFingerprint } from "@Routes/AccountLinks";

import { getFingerprintAsync, initializePC } from "./zero-fraud";

const DeviceFingerprint: FC<{
    loginScreen: "onet";
    userId?: string;
    onRequested?: () => void;
}> = ({ loginScreen, userId, onRequested }) => {
    useEffect(() => {
        const persistentCookie = initializePC();
        getFingerprintAsync()
            .then((fingerprint) => {
                if (fingerprint && persistentCookie) {
                    return PostAndForget(
                        BrowserFingerprint,
                        {
                            fpt: btoa(JSON.stringify(fingerprint)),
                            ptc: btoa(persistentCookie),
                            lscn: btoa(loginScreen),
                            uId: userId,
                        },
                        {},
                        onRequested,
                    );
                }
            })
            .catch((r) => {
                console.error(r);
                onRequested();
            });
    }, [loginScreen, onRequested, userId]);

    return null;
};

export default DeviceFingerprint;
